import React from 'react';
const zIndexContext = React.createContext(undefined);
export default zIndexContext;
